import axios from 'axios';
import {restApiPlain} from "@/components/mixins/RestApiMixin";

const rest = restApiPlain;

const state = () => ({
    isLoading: false,
    selectedContractId: null,
    selectedContract: {},
    selectedContractIds: [],
    selectedContracts: [],
    selectedGeometryOrders: [],
    selectedTaskType: null,
    selectedTaskTypes: [],
    selectedFromDate: null,
    selectedToDate: null,
    selectedOrder: null,
    selectedOrderStatuses: [],
    showContractGeometry: false,
    showContractGeometryLabels: false,
    showTrafficControl: false,
    historyMode: null,
    historyHours: 6,
    error: '',
    cancelRequest: null,
});

const actions = {
    selectContracts({ commit, dispatch }, contracts) {
        if (!contracts) {
            commit('SELECT_CONTRACTS', null);
            return;
        }
        dispatch('selectTaskType', null);
        dispatch('selectGeometryOrders', []);
        commit('SELECT_CONTRACTS', contracts);
    },
    setShowTrafficControl({ commit }, showTrafficControl) {
        commit('SET_SHOW_TRAFFIC_CONTROL', showTrafficControl);
    },
    setShowContractGeometry({ commit }, showContractGeometry) {
        commit('SET_SHOW_CONTRACT_GEOMETRY', showContractGeometry);
    },
    setHistoryMode({ commit }, historyMode) {
        commit('SET_HISTORY_MODE', historyMode);
    },
    setHistoryHours({ commit }, historyHours) {
        commit('SET_HISTORY_HOURS', historyHours);
    },
    setFromDate({ commit }, fromDate) {
        commit('SET_FROM_DATE', fromDate);
    },
    setToDate({ commit }, toDate) {
        commit('SET_TO_DATE', toDate);
    },
    selectGeometryOrders({ commit }, orders) {
        commit('SELECT_GEOMETRY_ORDERS', orders);
    },
    setShowContractGeometryLabels({ commit }, showContractGeometryLabels) {
        commit('SET_SHOW_CONTRACT_GEOMETRY_LABEL', showContractGeometryLabels);
    },
    selectTaskType({ commit }, taskType) {
        commit('SELECT_TASKTYPE', taskType ?? null);
    },
    setTaskTypes({ commit }, taskTypes) {
        commit('SET_TASKTYPES', taskTypes ?? []);
    },
    selectOrder({ commit }, order) {
        commit('SELECT_ORDER', order ?? null);
    },
    selectOrderStatuses({ commit }, statuses) {
        commit('SET_ORDER_STATUSES', statuses);
    },
    clearOrderStatuses({ commit }) {
        commit('CLEAR_ORDER_STATUSES');
    },
    async getContracts({ commit, rootState, dispatch }, params) {
        dispatch('cancelRequest');

        commit('SET_ERROR', '');
        commit('SET_LOADING', true);

        const source = axios.CancelToken.source();

        commit('CANCEL_REQUEST', source.cancel);

        try {
            const response = await axios.get(rest.contractUrl, {
                cancelToken: source.token,
                headers: {
                    Authorization: rootState.token
                },
                params
            });
            return response.data;
        } catch (err) {
            if (axios.isCancel(err)) return;
            commit('SET_ERROR', 'Could not get contracts');
        } finally {
            commit('SET_LOADING', false);
            commit('CANCEL_REQUEST', null);
        }
    },
    cancelRequest({ state }) {
        if (state.cancelRequest) {
            state.cancelRequest();
        }
    }
}

const mutations = {
    SELECT_CONTRACTS(state, contracts) {
        state.selectedContractIds = contracts?.length > 0 ? contracts.map(item => item.id) : [];
        state.selectedContracts = contracts?.length > 0 ? contracts : [];
        if (!contracts || contracts.length < 1) {
            state.showContractGeometry = false;
            state.showContractGeometryLabels = false;
        }
    },
    SELECT_GEOMETRY_ORDERS(state, orders) {
        state.selectedGeometryOrders = orders?.length > 0 ? orders.map(item => item.id) : [];
        if (!orders || orders.length < 1) {
            state.showContractGeometry = false;
            state.showContractGeometryLabels = false;
        }
    },
    SELECT_TASKTYPE(state, taskType) {
        state.selectedTaskType = taskType ?? null;
    },
    SET_TASKTYPES(state, taskTypes) {
        state.selectedTaskTypes = taskTypes;
    },
    SELECT_ORDER(state, order) {
        state.selectedOrder = order ?? null;
    },
    SET_ORDER_STATUSES(state, statuses) {
        state.selectedOrderStatuses = statuses;
    },
    CLEAR_ORDER_STATUSES(state) {
        state.selectedOrderStatuses = [];
    },
    SET_HISTORY_MODE(state, historyMode) {
        state.historyMode = historyMode;
    },
    SET_HISTORY_HOURS(state, historyHours) {
        state.historyHours = historyHours;
    },
    SET_FROM_DATE(state, fromDate) {
        state.selectedFromDate = fromDate ?? null;
    },
    SET_TO_DATE(state, toDate) {
        state.selectedToDate = toDate ?? null;
    },
    SET_LOADING(state, isLoading) {
        state.isLoading = isLoading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    SET_SHOW_CONTRACT_GEOMETRY(state, showContractGeometry) {
        state.showContractGeometry = showContractGeometry;
    },
    SET_SHOW_CONTRACT_GEOMETRY_LABEL(state, showContractGeometryLabels) {
        state.showContractGeometryLabels = showContractGeometryLabels;
    },
    SET_SHOW_TRAFFIC_CONTROL(state, showTrafficControl) {
        state.showTrafficControl = showTrafficControl;
    },
    CANCEL_REQUEST(state, func) {
        state.cancelRequest = func;
    }
}

// Export as default for Vuex module
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
